import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import { DownloadService } from '../../services/download/download.service';
import { saveAs } from 'file-saver/FileSaver';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { SharedVals } from '../../../shared/SharedVals';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-download-control',
  templateUrl: './download-control.component.html',
  styleUrls: ['./download-control.component.css']
})

export class DownloadControlComponent implements OnInit, OnDestroy {
  @Input() fileName;
  @Input() filePath;
  @Input() uploadedFileName;
  @Input() isW9Form: string = 'false';
  signedUrl;
  firstName;
  lastName;
  vendorName;
  role;
  errorMsg:boolean = false;
  agentId:any;
  subscription: ISubscription;

  constructor(private downloadService: DownloadService,
              private googleAnalyticsService:GoogleAnalyticsService,
              public sharedVals: SharedVals) { }

  ngOnInit() {
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.vendorName = localStorage.getItem('AgentName');
    this.role = localStorage.getItem("Role");
    this.agentId = localStorage.getItem("AgentId");
  }

  downloadDocument(){
    this.subscription = this.sharedVals.roleData.subscribe(roleData => {
      if (roleData !== 'PC Client' || this.isW9Form !== 'true') {
        let body = {
          "filePath": this.filePath,
          "vendor_id":this.agentId
        }

        this.downloadService.getDownloadSignedURL(body).subscribe((res) => {
         
          this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Downloaded a" + ' ' + this.uploadedFileName + ' ' + 'Document', this.vendorName, 10);
          this.signedUrl = res.Info;
          window.open(this.signedUrl, "_blank");
        });
      }
    }, err => {
      
    });
    /*this.role = localStorage.getItem("Role");
    if (this.isW9Form !== 'true' || this.role !== "Client") {
      let body = {
        "filePath": this.filePath,
        "vendor_id":this.agentId
      }

      this.downloadService.getDownloadSignedURL(body).subscribe((res) => {
        
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Downloaded a" + ' ' + this.uploadedFileName + ' ' + 'Document', this.vendorName, 10);
        this.signedUrl = res.Info;
        window.open(this.signedUrl, "_blank");
      })
    }*/
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/components/download-control/download-control.component.ts